export * from "./grupodeoperacao-edit.component";
export * from "./grupodeoperacao-browse.component";
